import { TopicHelper } from '../helpers/TopicHelper'
import { QuestionHelper } from '../helpers/QuestionHelper'
import { QuizHelper } from '../helpers/QuizHelper'

export const setupHelpers = (root) => {
  QuestionHelper.setRootStore(root)
  QuizHelper.setRootStore(root)
  TopicHelper.setRootStore(root)
}
